module.exports = __webpack_public_path__ + "static/media/discourse.e0f3b8b6.png";